const MULTI_WORD_MAKE_NAMES = [
  'alfa_romeo',
  'aston_martin',
  'ds_automobiles',
  'great_wall',
  'land_rover',
  'lynk_and_co',
  'mercedes_benz',
  'mg_motor_uk',
  'mitsubishi_fuso',
  'rolls_royce',
  'great_wall',
];

export { MULTI_WORD_MAKE_NAMES };
